import { MedicalNoteType, PatientNoteActivity } from '@uplift/api';
import { CommunicationNoteReview } from './CommunicationNote';
import { DischargeNoteReview } from './DischargeNote';
import { ReviewLayoutContent } from '../../../../../../Layout';
import { ClaimCorrectionNoteReview } from './ClaimCorrectionNote';
import { useUserDisplayNameQuery, useUserProfileQuery } from '@uplift/queries';

export type BaseMedicalNoteReviewProps = {
  activityItem: PatientNoteActivity;
};

export const BaseMedicalNoteReview: React.VFC<BaseMedicalNoteReviewProps> = props => {
  const { note, provider, patient } = props.activityItem;
  const coderId = note.additionalDetails?.coderId;
  const { data: coderNameData } = useUserDisplayNameQuery(coderId, { enabled: !!coderId });
  const { data: providerProfile } = useUserProfileQuery(provider.id);


  const patientTitle = `${patient.firstName} ${patient.lastName}`;
  const subtitle = `with ${provider.firstName[0]}. ${provider.lastName}`;
  const coder = `added by ${coderNameData?.first[0]}. ${coderNameData?.last}`;

  switch (note.noteType) {
    case MedicalNoteType.communicationNote:
      return (
        <ReviewLayoutContent title="Communication" subtitle={subtitle}>
          <CommunicationNoteReview provider={provider} note={note} />
        </ReviewLayoutContent>
      );
    case MedicalNoteType.therapyDischargeNote:
    case MedicalNoteType.psychiatryDischargeNote:
      return (
        <ReviewLayoutContent title={patientTitle} subtitle={subtitle} contentSpacing={false}>
          <DischargeNoteReview provider={provider} note={note} />
        </ReviewLayoutContent>
      );
    case MedicalNoteType.claimCorrectionNote:
      return (
        <ReviewLayoutContent title="Claim Correction" subtitle={coder}>
          <ClaimCorrectionNoteReview provider={provider} note={note} timezone={providerProfile?.timezone ?? ''} />
        </ReviewLayoutContent>
      );
    default:
      return null;
  }
};
